// Preloaded list of legal-sector contacts (sourced via app.apollo.io) used by
// the Motivational Letter Generator's "Speculative applications" panel.
//
// These are unsolicited-application targets: the recipient did NOT advertise
// a role. The generator uses this list to preload the employer, recipient,
// city and a courteous jobText brief that instructs the AI to write a
// highly professional unsolicited enquiry disclosing Apollo.io as the source
// of the contact details.

export type SpeculativeLegalContact = {
  /** Display id (email is unique). */
  id: string;
  name: string;
  position: string; // "" when unknown — the AI will fall back to "Director / Hiring Manager"
  company: string;
  location: string; // "" when unknown
  businessEmail: string;
  personalEmail?: string;
};

/** Combined roles the candidate is open to (used verbatim in the generated letter). */
export const SPECULATIVE_COMBINED_ROLE =
  "Articles of Clerkship, Candidate Attorney, Paralegal, Legal Assistant, or Internship";

export const SPECULATIVE_LEGAL_CONTACTS: SpeculativeLegalContact[] = [
  {
    id: "thabelo.mudimeli@timdutoit.co.za",
    name: "Thabelo Mudimeli",
    position: "Director",
    company: "Tim du Toit & Co Incorporated",
    location: "Gauteng, South Africa",
    businessEmail: "thabelo.mudimeli@timdutoit.co.za",
    personalEmail: "mudimeliabbygail@gmail.com",
  },
  {
    id: "sarah@hahnlaw.co.za",
    name: "Sarah Molele",
    position: "Consultant",
    company: "Hahn & Hahn Attorneys",
    location: "Pretoria, South Africa",
    businessEmail: "sarah@hahnlaw.co.za",
  },
  {
    id: "mmhlongo@gminc.co.za",
    name: "Mbali Mhlongo",
    position: "Human Resources Manager",
    company: "Gildenhuys Malatji Inc.",
    location: "Johannesburg, South Africa",
    businessEmail: "mmhlongo@gminc.co.za",
  },
  {
    id: "wanda@gertnelattorneys.co.za",
    name: "Wanda Richardson",
    position: "Litigation Secretary",
    company: "Gert Nel Incorporated Attorneys",
    location: "Pretoria, South Africa",
    businessEmail: "wanda@gertnelattorneys.co.za",
  },
  {
    id: "chantal@smitcompliance.com",
    name: "Chantal Sebastiao",
    position: "CEO and Founder",
    company: "SMIT Compliance (Pty) Ltd",
    location: "Johannesburg, South Africa",
    businessEmail: "chantal@smitcompliance.com",
  },
  {
    id: "tshikosi@tshikosiattorneys.co.za",
    name: "Tshikosi Attorneys",
    position: "Managing Director",
    company: "Tshikosi Attorneys",
    location: "Gauteng, South Africa",
    businessEmail: "tshikosi@tshikosiattorneys.co.za",
  },
  {
    id: "thandeka@ddpa.co.za",
    name: "Thandeka Dube",
    position: "Administrative Assistant",
    company: "DDP Attorneys Inc.",
    location: "Pretoria, South Africa",
    businessEmail: "thandeka@ddpa.co.za",
  },
  {
    id: "ruan@mariusblom.co.za",
    name: "Ruan Merwe",
    position: "Director",
    company: "Marius Blom Inc.",
    location: "Johannesburg, South Africa",
    businessEmail: "ruan@mariusblom.co.za",
  },
  {
    id: "leon@delberg.co.za",
    name: "Leon Delport",
    position: "Director",
    company: "Delberg Attorneys",
    location: "Johannesburg, South Africa",
    businessEmail: "leon@delberg.co.za",
  },
  {
    id: "zama@welmanbloem.co.za",
    name: "Zama Mkize",
    position: "Articles of Clerkship",
    company: "Welman Attorneys Inc.",
    location: "Pretoria, South Africa",
    businessEmail: "zama@welmanbloem.co.za",
  },
  {
    id: "holofelang@kcinc.co.za",
    name: "Holofelang Phahlane",
    position: "Paralegal",
    company: "Kgobokoe & Company Incorporated",
    location: "Pretoria, South Africa",
    businessEmail: "holofelang@kcinc.co.za",
  },
  {
    id: "sherese@pvanren.co.za",
    name: "Sherese Moonsamy",
    position: "Attorney, Notary, Conveyancer",
    company: "Jansen van Rensburg Conco Inc. Attorneys and Conveyancers",
    location: "Johannesburg, South Africa",
    businessEmail: "sherese@pvanren.co.za",
  },
  {
    id: "nel@nvsinc.co.za",
    name: "Wiam Nel",
    position: "Managing Director",
    company: "Nel Van der Merwe & Smalman Inc",
    location: "Pretoria, South Africa",
    businessEmail: "nel@nvsinc.co.za",
  },
  {
    id: "michael@kpinc.co.za",
    name: "Michael Kirkcaldy",
    position: "Attorney / Entrepreneur, Director",
    company: "Kirkcaldy Pereira Inc",
    location: "Gauteng, South Africa",
    businessEmail: "michael@kpinc.co.za",
  },
  {
    id: "khopotso@selepekr.co.za",
    name: "Khopotso Selepe",
    position: "Managing Partner",
    company: "Selepe KR Attorneys, Notaries & Conveyancers",
    location: "Johannesburg, South Africa",
    businessEmail: "khopotso@selepekr.co.za",
  },
  {
    id: "wendy.gordon@intermountainhealthcare.org",
    name: "",
    position: "",
    company: "Intermountain Healthcare",
    location: "",
    businessEmail: "wendy.gordon@intermountainhealthcare.org",
  },
  {
    id: "viola.mugwisi@ppmattorneys.co.za",
    name: "Viola Mugwisi",
    position: "",
    company: "PPM Attorneys",
    location: "",
    businessEmail: "viola.mugwisi@ppmattorneys.co.za",
  },
  {
    id: "seloff@mcinc.africa",
    name: "Sunelle Eloff",
    position: "",
    company: "MC Inc. Africa",
    location: "",
    businessEmail: "seloff@mcinc.africa",
  },
  {
    id: "nreyneke@mdalaw.co.za",
    name: "Natalie Reyneke",
    position: "",
    company: "MDA Law",
    location: "",
    businessEmail: "nreyneke@mdalaw.co.za",
  },
  {
    id: "simon@mkhwanazi.com",
    name: "",
    position: "",
    company: "Mkhwanazi Attorneys",
    location: "",
    businessEmail: "simon@mkhwanazi.com",
  },
  {
    id: "zama@wmnattorneys.com",
    name: "Zama Ngcobo",
    position: "",
    company: "WMN Attorneys",
    location: "",
    businessEmail: "zama@wmnattorneys.com",
  },
  {
    id: "megan@hjw.co.za",
    name: "Megan Friedman",
    position: "",
    company: "HJW Attorneys",
    location: "",
    businessEmail: "megan@hjw.co.za",
  },
  {
    id: "dbotha@dsclaw.co.za",
    name: "",
    position: "",
    company: "DSC Law",
    location: "",
    businessEmail: "dbotha@dsclaw.co.za",
  },
  {
    id: "di@gibsoninc.co.za",
    name: "Di Gibson",
    position: "",
    company: "Gibson Inc.",
    location: "",
    businessEmail: "di@gibsoninc.co.za",
  },
  {
    id: "vanrensburg@schindlers.co.za",
    name: "Simone Van Rensburg",
    position: "",
    company: "Schindlers Attorneys",
    location: "",
    businessEmail: "vanrensburg@schindlers.co.za",
  },
  {
    id: "nabeelah@lhr.org.za",
    name: "Nabeelah Mia",
    position: "",
    company: "Lawyers for Human Rights",
    location: "",
    businessEmail: "nabeelah@lhr.org.za",
  },
  {
    id: "nash@burgerhuyserattorneys.co.za",
    name: "Nash Mogale",
    position: "",
    company: "Burger Huyser Attorneys",
    location: "",
    businessEmail: "nash@burgerhuyserattorneys.co.za",
  },
  {
    id: "yaronw@emguidance.com",
    name: "Yaron Waks",
    position: "",
    company: "Spence Attorneys, Notaries & Conveyancers / EM Guidance",
    location: "",
    businessEmail: "yaronw@emguidance.com",
  },
  {
    id: "e.jonker@svw.co.za",
    name: "Esmari Jonker",
    position: "",
    company: "Smit & Van Wyk",
    location: "",
    businessEmail: "e.jonker@svw.co.za",
  },
  {
    id: "bertus@stratlaw.co.za",
    name: "Bertus Coetzee",
    position: "",
    company: "StratLaw",
    location: "",
    businessEmail: "bertus@stratlaw.co.za",
  },
];

/**
 * Build the jobText brief that primes the AI prompts (generate / email /
 * tailor_cv) to produce a highly professional UNSOLICITED enquiry addressed
 * to a recipient we do not know personally, disclosing Apollo.io as the
 * source of the contact details.
 *
 * We inject this into the existing `jobText` field so no API change is
 * required — the AI system prompts already read jobText as the job source.
 */
/**
 * Vacancy focus for a speculative letter. Controls how the letter frames
 * the ask: only currently available openings, only future vacancies, or
 * both. All three modes still address the same specific person and firm
 * in a single unified letter.
 */
export type VacancyMode = "current" | "future" | "both";

export function buildSpeculativeBrief(
  c: SpeculativeLegalContact,
  vacancyMode: VacancyMode = "both",
): string {
  const hasName = Boolean(c.name && c.name.trim());
  const recipientFull =
    hasName && c.position
      ? `${c.name} (${c.position})`
      : hasName
        ? c.name
        : c.position || "the Director / Hiring Partner";
  const salutationLine = hasName
    ? `MANDATORY salutation: "Dear ${c.name}," — use this exact name. Do NOT write "Dear Sir/Madam", "Dear Hiring Manager", "To Whom It May Concern" or any generic greeting.`
    : `No personal name is on file for this contact. Address the letter to "Dear ${c.position || "Director / Hiring Partner"}, ${c.company}" and keep it directed specifically at this firm — never generic.`;
  const addressBlock = hasName
    ? `MANDATORY address block at the top of the letter:\n${c.name}${c.position ? `\n${c.position}` : ""}\n${c.company}${c.location ? `\n${c.location}` : ""}`
    : `MANDATORY address block at the top of the letter:\n${c.position || "The Director / Hiring Partner"}\n${c.company}${c.location ? `\n${c.location}` : ""}`;
  const locLine = c.location ? `Firm location: ${c.location}\n` : "";

  const vacancyPhrase =
    vacancyMode === "current"
      ? "any currently available"
      : vacancyMode === "future"
        ? "any future"
        : "any current or future";
  const vacancyPhraseTitle =
    vacancyMode === "current"
      ? "Current openings only"
      : vacancyMode === "future"
        ? "Future vacancies only"
        : "Current and/or future vacancies";

  const vacancyDirective =
    vacancyMode === "current"
      ? [
          `VACANCY FOCUS — CURRENT OPENINGS ONLY:`,
          `Frame the entire letter around ANY position (e.g. Internship, Paralegal, Legal Assistant, Candidate Attorney or Articles of Clerkship) that is CURRENTLY AVAILABLE at ${c.company} today. Use present-tense phrasing such as "I would be grateful to be considered for any of the above roles that may currently be open at ${c.company}." Do NOT discuss future or hypothetical vacancies in this letter.`,
        ].join("\n")
      : vacancyMode === "future"
        ? [
            `VACANCY FOCUS — FUTURE VACANCIES ONLY:`,
            `Frame the entire letter around ANY FUTURE opening (e.g. a future Internship, Paralegal, Legal Assistant, Candidate Attorney or Articles of Clerkship position) at ${c.company}. Use forward-looking phrasing such as "should any of the above positions — for example an Internship or Candidate Attorney vacancy — become available in the future at ${c.company}, I would welcome the opportunity to be considered." Politely ask that the candidate's details be kept on file. Do NOT imply the firm has a current vacancy.`,
          ].join("\n")
        : [
            `VACANCY FOCUS — CURRENT AND FUTURE:`,
            `Frame the entire letter as an enquiry about ANY current OR future vacancy at ${c.company} across the listed roles (e.g. Internship or Candidate Attorney). Address BOTH scenarios in a single dedicated paragraph such as: "I would be grateful to be considered for any of the above roles — for example an Internship or Candidate Attorney position — that ${c.company} may currently have open, and, should nothing be available at present, I would equally welcome being kept in mind for any future vacancy that may arise." Keep it in one paragraph, not two, so the letter still reads as a single unified enquiry to the same person.`,
          ].join("\n");

  return [
    `SPECULATIVE / UNSOLICITED APPLICATION — no role has been advertised.`,
    `Purpose of this letter: a single professional enquiry about ${vacancyPhrase} vacancy at ${c.company} across the roles listed below (for example an Internship or Candidate Attorney position). This framing (${vacancyPhraseTitle}) MUST be carried consistently through the RE line, opening paragraph, the ask, and the closing — never reduced to a generic "speculative application".`,
    ``,
    `Recipient: ${recipientFull}`,
    `Firm / employer: ${c.company}`,
    locLine.trim(),
    `Contact email: ${c.businessEmail}`,
    ``,
    addressBlock,
    ``,
    salutationLine,
    ``,
    `HOW THE CANDIDATE FOUND THIS CONTACT:`,
    `The recipient's professional contact details were obtained from Apollo.io (app.apollo.io), a reputable B2B business-contact directory. This must be disclosed briefly and courteously in both the letter and the email so the recipient knows the source of their details.`,
    ``,
    `SINGLE COMBINED LETTER — STRICT:`,
    `Produce ONE motivational letter that covers ALL of the positions below as a single, unified enquiry about ${vacancyPhrase} vacancy at ${c.company}. Do NOT write separate paragraphs "for each role" and do NOT split the letter into sections per position. List the positions once and treat them as a single ask:`,
    `- Articles of Clerkship`,
    `- Candidate Attorney`,
    `- Paralegal`,
    `- Legal Assistant`,
    `- Internship (legal / compliance)`,
    ``,
    vacancyDirective,
    ``,
    `MANDATORY CONTENT (in this order):`,
    `1. Address block (as specified above), then the exact salutation "Dear ${hasName ? c.name : (c.position || "Director / Hiring Partner")},".`,
    `2. RE line MUST use this exact format and MUST match the vacancy focus above — never shortened to "Speculative application":`,
    `   "RE: Application for ${vacancyPhrase} vacancy — Articles of Clerkship, Candidate Attorney, Paralegal, Legal Assistant or Internship at ${c.company}"`,
    `3. Opening paragraph MUST (a) include a courteous apology for reaching out without any prior contact or introduction (for example: "I respectfully ask your indulgence for approaching you directly without a prior introduction…"), and (b) state plainly that the letter is an enquiry about ${vacancyPhrase} vacancy at ${c.company} across the listed roles (e.g. an Internship or Candidate Attorney position). Keep it dignified — never grovelling.`,
    `4. Immediately after the apology, briefly disclose that the recipient's contact details were obtained via Apollo.io (app.apollo.io).`,
    `5. Introduce the candidate in 2-4 sentences, tied specifically to ${c.company} and (where possible) the South African legal sector — never generic.`,
    `6. Apply the VACANCY FOCUS directive above to phrase the ask correctly; the ask paragraph MUST explicitly reference "${vacancyPhrase} vacancy" (or equivalent wording) and give at least one concrete example role such as an Internship or Candidate Attorney position at ${c.company}.`,
    `7. Align the candidate's strengths with typical duties at a South African legal practice (research, drafting, litigation support, client liaison, compliance, POPIA/FICA, document management) — pick the ones actually supported by the CV.`,
    `8. Close by respectfully asking the recipient to keep the candidate's details on file for ${vacancyPhrase} suitable opening and offering to send additional documents (CV, transcripts, references) on request.`,
    ``,
    `TONE & ANTI-GENERIC RULES (STRICT):`,
    `- The letter MUST be directed personally to ${hasName ? c.name + " at " + c.company : c.company}. Reference the firm by name (${c.company}) at least twice in the body.`,
    `- Do NOT write a generic template that could be sent to any firm — every paragraph must feel written for ${c.company} specifically.`,
    `- Do NOT frame the letter as a generic "speculative application"; it is an enquiry about ${vacancyPhrase} vacancy across the listed roles at ${c.company}.`,
    `- Do NOT invent that ${c.company} has vacancies, do NOT reference a specific advertised role, reference number or closing date, and do NOT claim personal acquaintance with the recipient.`,
    `- Do NOT use "Dear Sir/Madam", "To Whom It May Concern", "Dear Hiring Manager", "Dear Hiring Team" or any generic salutation under any circumstances.`,
    `- Formal, respectful, courteous — never presumptuous, never over-familiar, never casual.`,
  ]

    .filter(Boolean)
    .join("\n");
}

/**
 * Forbidden generic phrases used by the client-side guardrail. Kept here so
 * the brief and the validator stay in sync.
 */
export const FORBIDDEN_GENERIC_PHRASES: readonly string[] = [
  "Dear Sir/Madam",
  "Dear Sir or Madam",
  "To Whom It May Concern",
  "Dear Hiring Manager",
  "Dear Hiring Team",
  "Dear Recruiter",
  "Dear Recruitment Team",
];

/** Phrases that count as the required apology for unsolicited contact. */
export const APOLOGY_PHRASE_HINTS: readonly string[] = [
  "apolog",
  "indulgence",
  "forgive",
  "without prior",
  "without a prior",
  "unsolicited",
  "approaching you directly",
  "unannounced",
];

export type SpeculativeLetterIssue = {
  code:
    | "missing_recipient"
    | "wrong_recipient"
    | "missing_company"
    | "missing_apology"
    | "forbidden_phrase"
    | "generic_salutation";
  severity: "error" | "warn";
  message: string;
};

/**
 * Validate a generated letter against a selected Apollo.io contact. Returns
 * a list of issues (errors block download, warnings show a caution). All
 * checks are case-insensitive and tolerant of whitespace.
 */
export function validateSpeculativeLetter(
  fullText: string,
  contact: SpeculativeLegalContact | null,
): SpeculativeLetterIssue[] {
  const issues: SpeculativeLetterIssue[] = [];
  const text = (fullText || "").trim();
  if (!text) return issues;
  const lower = text.toLowerCase();

  // Forbidden generic phrases (hard error).
  for (const p of FORBIDDEN_GENERIC_PHRASES) {
    if (lower.includes(p.toLowerCase())) {
      issues.push({
        code: "forbidden_phrase",
        severity: "error",
        message: `Contains forbidden generic phrase: "${p}". Regenerate — the letter must address the specific person by name.`,
      });
    }
  }

  if (contact) {
    // Recipient name must appear (if we have one on file).
    if (contact.name && contact.name.trim()) {
      const first = contact.name.trim().split(/\s+/)[0]?.toLowerCase() || "";
      const nameOk = lower.includes(contact.name.toLowerCase()) ||
        (first.length > 1 && lower.includes(`dear ${first}`));
      if (!nameOk) {
        issues.push({
          code: "wrong_recipient",
          severity: "error",
          message: `Recipient name "${contact.name}" is missing from the letter. Every speculative letter must address the person by name.`,
        });
      } else {
        // Salutation check — "Dear <Name>," ideally.
        const dearRe = new RegExp(`dear\\s+${first}`, "i");
        if (!dearRe.test(lower)) {
          issues.push({
            code: "missing_recipient",
            severity: "warn",
            message: `Salutation does not start with "Dear ${contact.name}". Consider regenerating.`,
          });
        }
      }
    }

    // Company name must appear at least once (ideally twice).
    if (contact.company && contact.company.trim()) {
      const company = contact.company.trim();
      const occurrences = lower.split(company.toLowerCase()).length - 1;
      if (occurrences === 0) {
        issues.push({
          code: "missing_company",
          severity: "error",
          message: `Firm name "${company}" is not mentioned in the letter. The letter must be directed to this specific firm.`,
        });
      } else if (occurrences < 2) {
        issues.push({
          code: "missing_company",
          severity: "warn",
          message: `Firm name "${company}" appears only once — the brief asks for at least twice so it doesn't read as a generic template.`,
        });
      }
    }
  }

  // Apology check (hard error for speculative letters).
  const hasApology = APOLOGY_PHRASE_HINTS.some((h) => lower.includes(h));
  if (!hasApology) {
    issues.push({
      code: "missing_apology",
      severity: "error",
      message:
        "Missing apology for unsolicited contact. The opening paragraph must politely ask forgiveness for approaching the firm without prior contact.",
    });
  }

  // Generic salutation as a fallback check (also caught by forbidden list).
  if (/dear\s+(sir|madam|hiring|recruiter|recruitment|team)\b/i.test(text)) {
    if (!issues.some((i) => i.code === "forbidden_phrase")) {
      issues.push({
        code: "generic_salutation",
        severity: "error",
        message: "Salutation is generic. Address the specific person by name.",
      });
    }
  }

  return issues;
}
